export function popups() {
    $(window).on("load", function () {
        const mainWrap = $("body");

        function closePopup() {
            $(".popup").removeClass("active");
            mainWrap.removeClass("popup-open");
        }

        $(document).on("click", ".popup-link", function (event) {
            event.preventDefault();

            let $this = $(this);
            let $url = $this.attr("href");
            let parseUrl = $url.split('#');
            let $target = '#' + parseUrl[1];

            $($target).addClass("active").fadeIn(300);
            mainWrap.addClass("popup-open");

        }).on("click", ".popup-close", function () {
            closePopup.call(this);
        });


        $(".popups").on("click", function (event) {
            if (!$(event.target).closest(".popup-holder").length && !$(event.target).parents('.jcf-select-drop').length) {
                closePopup.call(this);
            }
        });
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js